import React , {useEffect, useState} from 'react'
import Pagination from '@mui/material/Pagination'
import {Box, Stack, Typography} from '@mui/material'
import ExerciseCard from '../components/ExerciseCard'
import {exerciseOptions, fetchData } from '../utils/fetchData'

function Exercises({exercises, setExercises, bodyPart}) {


  const [currentPage, setCurrentPage] = useState(1)

  const [exercisesPerPage] = useState(9);

  const indexOfLastExercise = currentPage * exercisesPerPage;
  const indexOfFirstExercise = indexOfLastExercise - exercisesPerPage;
  const currentExercises = exercises.slice(indexOfFirstExercise, indexOfLastExercise);

  const paginate = (e, value) => {

    setCurrentPage(value);

    window.scrollTo({top: 1800, behavior: 'smooth'})
  }

  //this useEffect/method recalls the api data every time a category is selected 
  useEffect(() => {
    const fetchExercisesData = async ()=> {
      let exercisesData = [];
     
      if(bodyPart === 'all'){
        exercisesData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions)
      }else{
        //using backticks changes the url into a template
        exercisesData = await fetchData(`https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`, exerciseOptions);
      }

      setExercises(exercisesData)
    
    }

    fetchExercisesData();

  } , [bodyPart]);

  return (
    <Box id="exercises" sx={{ mt: { lg: '109px' } }} mt="50px" p="20px">

    <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { lg: '44px', xs: '30px' } }} mb="46px">Showing Results</Typography>

    <Stack direction="row" sx={{ gap: { lg: '107px', xs: '50px' } }} flexWrap="wrap" justifyContent="center">

      {currentExercises.map((exercise, idx) => (

        <ExerciseCard key={idx} exercise={exercise} />
        
      ))}
    </Stack>
    <Stack sx={{ mt: { lg: '114px', xs: '70px' } }} alignItems="center">
      {exercises.length > 9 && (
        <Pagination
          color="standard"
          shape="rounded"
          defaultPage={1}
          count={Math.ceil(exercises.length / 9)}
          page={currentPage}
          onChange={paginate}
          size="large"
        />
      )}
    </Stack>
  </Box>
  )
}

export default Exercises